import { Alert, getAlertHighlightCellKeys } from '@aloft/toolkit-shared';

import { PropertyGridCellKey } from '../../components/PropertyGrid/types.ts';

const isAlertTargetCell = (alert: Alert, cellKey: PropertyGridCellKey): boolean =>
  getAlertHighlightCellKeys(alert).includes(cellKey);

export const getActiveAlertForPropertyGridCell = (
  alerts: Record<string, Alert[]>,
  cellKey: PropertyGridCellKey,
): Alert | undefined =>
  Object.values(alerts)
    .flat()
    .find((alert) => alert.status === 'active' && isAlertTargetCell(alert, cellKey));
